const URL_CONSENT_PARAM = "_cs";
function fetchConsentFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const param = urlParams.get(URL_CONSENT_PARAM);
  return param;
}

export { fetchConsentFromURL };
